// ==============================================================================
// CONFIGURAÇÕES E CONTATOS DA TRANSPORTADORA
// Informações institucionais utilizadas para suporte, avisos e atendimento.
// ==============================================================================

export interface TransportadoraInfo {
  nome: string;
  nomeExibicao: string;
  slogan: string;
  telefone: string;
  telefoneFormatado: string;
  whatsapp: string;
  whatsappFormatado: string;
  emailContato: string;
  emailComercial: string;
  emailFinanceiro: string;
  emailOperacional: string;
  horarioAtendimento: string;
}

export const TRANSPORTADORA_CONFIG: TransportadoraInfo = {
  nome: 'Voope Transportes & Logística',
  nomeExibicao: 'Voope TWO',
  slogan: 'Gestão Inteligente de Frotas e Logística',
  telefone: '1130000000',
  telefoneFormatado: '(11) 3000-0000',
  whatsapp: '5511987654321',
  whatsappFormatado: '(11) 98765-4321',
  emailContato: 'contato@voopetrans.com.br',
  emailComercial: 'comercial@voopetrans.com.br',
  emailFinanceiro: 'financeiro@voopetrans.com.br',
  emailOperacional: 'operacao@voopetrans.com.br',
  horarioAtendimento: 'Segunda a Sexta das 08h às 18h',
};

/**
 * Gera o link direto do WhatsApp com mensagem pré-definida de usuário inativo
 */
export function getWhatsAppSuporteUrl(userEmail?: string, userName?: string): string {
  const identificacao = [
    userName ? `Nome: ${userName}` : null,
    userEmail ? `E-mail: ${userEmail}` : null,
  ].filter(Boolean).join(' | ');

  const msg = `Olá, equipe da transportadora ${TRANSPORTADORA_CONFIG.nomeExibicao}!\n\nMeu usuário está com o status *Inativo* no sistema e preciso de suporte para regularizar/reativar o meu acesso.${identificacao ? `\n\nIdentificação: ${identificacao}` : ''}`;
  
  return `https://wa.me/${TRANSPORTADORA_CONFIG.whatsapp}?text=${encodeURIComponent(msg)}`;
}

/**
 * Gera o link mailto direto para a transportadora
 */
export function getEmailSuporteUrl(userEmail?: string, userName?: string): string {
  const subject = `[Suporte de Acesso] Usuário Inativo - ${userName || userEmail || 'Sistema Voope'}`;
  const body = `Olá equipe ${TRANSPORTADORA_CONFIG.nome},\n\nMeu acesso de usuário ao sistema consta como inativo.\n\nE-mail de cadastro: ${userEmail || ''}\nNome: ${userName || ''}\n\nPor favor, gostaria de verificar o motivo e solicitar a regularização/reativação do meu acesso.\n\nObrigado.`;

  return `mailto:${TRANSPORTADORA_CONFIG.emailContato}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
